const workflow = {
  workflow: {
    options: {
      min: {
        icon: 'turtle',
        value: '1500'
      },
      eco: {
        icon: 'leaf',
        value: '2500'
      },
      max: {
        icon: 'rabbit',
        value: '3600'
      }
    },
    engineNotStartedValues: [
      {
        icon: 'icon-xm-battery',
        value: '14.2'
      },
      {
        icon: 'icon-xm-bar-fuel',
        value: ''
      },
      {
        icon: 'icon-xm-drop-wrench',
        value: '463.2',
      },
      {
        icon: 'icon-xm-flask-wrench',
        value: '18.2'
      }
    ]
  }
};

export default workflow;



// WEBPACK FOOTER //
// ./src/screens/data/flow2/workflow.js